export enum EventType {
  Event = "event",
  Camp = "camp",
  Schedule = "schedule",
}

export interface Event {
  id: string;
  type?: EventType;
  boxColour?: string;
  boxBorder?: string;
  recurring: boolean;
  frequency: string;
  day: number;
  capacity: number;
  name: string;
  description: string;
  image?: string;
  startsAt: Date;
  endsAt: Date;
  startTime: string;
  endTime: string;
  rsvp: Array<string>;
  price?: string;
  paymentInfo?: string;
  payment: string;
  payment2: string;
  payment3: string;
  payment4: string;
  paymentFood: string;
  paymentFood2: string;
  paymentFood3: string;
  paymentFood4: string;
  tags?: string;
  startDate?: Date;
  endDate?: Date;
  noRegistration?: boolean;
  comingSoon?: boolean;
}

export interface ActivityRaw {
  id: string;
  recurring: string;
  frequency: string;
  day: string;
  capacity: string;
  name: string;
  description: string;
  startsAt: string;
  endsAt: string;
  rsvp: string;
  payment: string;
  payment2: string;
  payment3: string;
  payment4: string;
  paymentFood: string;
  paymentFood2: string;
  paymentFood3: string;
  paymentFood4: string;
  tags?: string;
  startDate?: string;
  endDate?: string;
  startTime?: string;
  endTime?: string;
  showFoodOption?: boolean;
  showExtendedHoursOption?: boolean;
  noRegistration?: boolean;
  comingSoon?: boolean;
}
